import React from "react";
import classNames from "classnames";

import "./style.css";
import { CircularProgress, Typography, Button } from "@mui/material";
import EntryItem from "./entryItem";
import { isInside } from "./utils";

export default class FileBrowser extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      multipleSelects: [],
      selecting: false,

      selectStartX: 0,
      selectStartY: 0,

      selectEndX: 0,
      selectEndY: 0,
    };
  }

  updateMultipleSelects = (multipleSelects) => {
    this.setState({ multipleSelects });
    typeof this.props.onMultipleSelected === "function" &&
      this.props.onMultipleSelected(multipleSelects);
  };

  rectangleSelect(selector, x1, y1, x2, y2) {
    const elements = [];
    document.querySelectorAll(selector).forEach((item) => {
      const x = item.offsetLeft;
      const y = item.offsetLeft;
      const w = item.clientWidth;
      const h = item.clientHeight;

      if (
        isInside(x, y, x1, y1, x2, y2) ||
        isInside(x, y + h, x1, y1, x2, y2) ||
        isInside(x + w, y, x1, y1, x2, y2) ||
        isInside(x + w, y + h, x1, y1, x2, y2)
      ) {
        // this element fits inside the selection rectangle
        elements.push(item);
      }
    });
    return elements;
  }

  getSelectedEntries = (elements) => {
    if (!Array.isArray(elements)) return;
    let multipleSelects = [];
    elements.forEach((item) => {
      let is_directory = item.getAttribute("data-is-directory");
      let path = item.getAttribute("data-path");
      if (
        is_directory === "true" ||
        is_directory === true ||
        is_directory === 1
      )
        return;
      multipleSelects.push(path);
    });

    this.updateMultipleSelects(multipleSelects);
  };

  handleTouchCancel = (e) => {
    this.setState({ selecting: false });
  };

  handleTouchStart = (e) => {
    let x = e.pageX;
    let y = e.pageY;

    this.updateMultipleSelects([]);

    this.setState({
      selecting: true,
      selectStartX: x,
      selectStartY: y,
      selectEndX: x,
      selectEndY: y,
    });
  };

  handleTouchMove = (e) => {
    if (!this.state.selecting) return;
    let x = e.pageX;
    let y = e.pageY;
    this.setState({ selectEndX: x, selectEndY: y });
  };

  handleTouchEnd = (e) => {
    const { selectStartX, selectEndX, selectStartY, selectEndY } = this.state;
    this.setState({ selecting: false });

    this.getSelectedEntries(
      this.rectangleSelect(
        ".fileBrowser .entry",
        Math.min(selectStartX, selectEndX),
        Math.min(selectStartY, selectEndY),
        Math.max(selectStartX, selectEndX),
        Math.max(selectStartY, selectEndY)
      )
    );
  };

  handleFilesUploaded = (e) =>
    typeof this.props.handleUpload === "function" &&
    this.props.handleUpload(e.target.files);

  handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ dragdropStarted: true });
  };

  handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ dragdropStarted: false });
  };

  handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  handleDragFinished = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let files = e.dataTransfer.files;
    typeof this.props.handleUpload === "function" &&
      this.props.handleUpload(files);
  };

  _renderFileList = (data) => {
    if (!Array.isArray(data)) return;
    const { selected, multipleSelects } = this.state;

    return (
      <div style={{ height: "100%", overflow: "auto" }}>
        {data
          .sort((a, b) => b.is_directory - a.is_directory)
          .map((entry, index) => {
            return (
              <EntryItem
                key={index}
                name={entry.name}
                is_selected={
                  entry.path === selected ||
                  multipleSelects.indexOf(entry.path) >= 0
                }
                path={entry.path}
                is_directory={entry.is_directory}
                onClick={() => {
                  this.setState({ selected: entry.path });
                  typeof this.props.handleClickItem === "function" &&
                    this.props.handleClickItem(entry);
                }}
                onDoubleClick={() => {
                  typeof this.props.handleDoubleClickItem === "function" &&
                    this.props.handleDoubleClickItem(entry);
                }}
              />
            );
          })}
      </div>
    );
  };

  _renderSelectHighlight = () => {
    if (!this.refContainer) return;
    const {
      selecting,
      selectStartX,
      selectEndX,
      selectStartY,
      selectEndY,
    } = this.state;
    if (!selecting) return;
    var rect = this.refContainer.getBoundingClientRect();

    let top = Math.min(selectStartY, selectEndY) - rect.top;
    let left = Math.min(selectStartX, selectEndX) - rect.left;
    let width = Math.abs(selectEndX - selectStartX);
    let height = Math.abs(selectEndY - selectStartY);

    return (
      <div
        className="select-highlight"
        style={{ top, left, width, height }}
      ></div>
    );
  };

  render() {
    const { loading, data } = this.props;
    return (
      <React.Fragment>
        <div
          ref={(ref) => (this.refContainer = ref)}
          className={classNames("fileBrowser")}
          onDragOver={this.handleDragOver}
          onDragEnter={this.handleDragEnter}
          onDragLeave={this.handleDragLeave}
          onDrop={this.handleDragFinished}
          onMouseDown={this.handleTouchStart}
          onTouchStart={this.handleTouchStart}
          onMouseMove={this.handleTouchMove}
          onTouchMove={this.handleTouchMove}
          onMouseUp={this.handleTouchEnd}
          onTouchEnd={this.handleTouchEnd}
          onTouchCancel={this.handleTouchCancel}
        >
          {this._renderFileList(data)}
          <div
            className="loading-container"
            style={{ display: loading ? "flex" : "none" }}
          >
            <CircularProgress />
          </div>
          {this._renderSelectHighlight()}
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            paddingTop: 10,
            paddingBottom: 10,
            paddingRight: 10,
          }}
        >
          <Typography variant="body2" color="textSecondary">
            Direct upload multiple files by drag n drop to explorer or&nbsp;
          </Typography>
          <Button
            variant="outlined"
            onClick={() => this.btnUpload && this.btnUpload.click()}
          >
            Click to upload
          </Button>
        </div>
        <input
          type="file"
          accept="image/x-png,image.jpeg"
          hidden
          multiple
          ref={(ref) => (this.btnUpload = ref)}
          onChange={this.handleFilesUploaded}
        />
      </React.Fragment>
    );
  }
}
